// API Configuration
const API_BASE_URL = 'https://cccigar.onrender.com';

export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: `${API_BASE_URL}/api/auth/login`,
    SIGNUP: `${API_BASE_URL}/api/auth/signup`,
    ME: `${API_BASE_URL}/api/auth/me`,
  },
  
  // Product endpoints
  PRODUCTS: {
    LIST: `${API_BASE_URL}/api/products`,
    CREATE: `${API_BASE_URL}/api/products`,
    GET: (id) => `${API_BASE_URL}/api/products/${id}`,
    UPDATE: (id) => `${API_BASE_URL}/api/products/${id}`,
    DELETE: (id) => `${API_BASE_URL}/api/products/${id}`,
  },
  
  // Order endpoints
  ORDERS: {
    CREATE: `${API_BASE_URL}/api/orders`,
    LIST: `${API_BASE_URL}/api/orders`,
  },
  
  // Admin endpoints
  ADMIN: {
    STATS: `${API_BASE_URL}/api/admin/stats`,
    RECENT_ORDERS: `${API_BASE_URL}/api/admin/recent-orders`,
    ORDERS: `${API_BASE_URL}/api/admin/orders`,
    USERS: `${API_BASE_URL}/api/admin/users`,
  }
};

export default API_BASE_URL;
